export default function(e){return String(e).replace(/[^\d]/g,"")};
